"use client";

import {
  Box,
  Container,
  Flex,
  Heading,
  Icon,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  FcAbout,
  FcAssistant,
  FcCollaboration,
  FcDonate,
  FcGlobe,
  FcLandscape,
  FcManager,
  FcViewDetails,
} from "react-icons/fc";
import Layout from "../../../layout/Layout";
import { ApiCard } from "../../../components/card";

export default function PlacesHome() {
  return (
    <Layout
      children={
        <Box p={4}>
          <Stack spacing={4} as={Container} maxW={"3xl"} textAlign={"center"}>
            <Heading fontSize={{ base: "2xl", sm: "4xl" }} fontWeight={"bold"}>
              Places APIs
            </Heading>
            <Text color={"gray.600"} fontSize={{ base: "sm", sm: "lg" }}>
              Leverage our Places APIs for powering your location-based
              applications.
            </Text>
          </Stack>

          <Container maxW={"5xl"} mt={12}>
            <Flex flexWrap="wrap" gridGap={6} justify="center">
              <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Autocomplete"}
                  icon={<Icon as={FcViewDetails} w={10} h={10} />}
                  description={"Provide optimized location search suggestions"}
                  href={"places/autocomplete"}
                />
              </Box>
              <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Details"}
                  icon={<Icon as={FcLandscape} w={10} h={10} />}
                  description={
                    "Detailed Information about POIs based on the POI ID"
                  }
                  href={"places/detail"}
                />
              </Box>
            </Flex>
          </Container>
        </Box>
      }
    />
  );
}
